/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OntimeSignInUserRequest
 */
export interface OntimeSignInUserRequest {
    /**
     * 
     * @type {string}
     * @memberof OntimeSignInUserRequest
     */
    token: string;
}

/**
 * Check if a given object implements the OntimeSignInUserRequest interface.
 */
export function instanceOfOntimeSignInUserRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "token" in value;

    return isInstance;
}

export function OntimeSignInUserRequestFromJSON(json: any): OntimeSignInUserRequest {
    return OntimeSignInUserRequestFromJSONTyped(json, false);
}

export function OntimeSignInUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OntimeSignInUserRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function OntimeSignInUserRequestToJSON(value?: OntimeSignInUserRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
    };
}

